import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostAuthPassword_reset_token = z.any()
export type TagsPostAuthPassword_reset_token = z.infer<typeof tagsPostAuthPassword_reset_token>

export const paramsPostAuthPassword_reset_token = z.object({ "token": z.string() })
export type ParamsPostAuthPassword_reset_token = z.infer<typeof paramsPostAuthPassword_reset_token>

export const bodyPostAuthPassword_reset_token = z.object({ "password": z.string() })
export type BodyPostAuthPassword_reset_token = z.infer<typeof bodyPostAuthPassword_reset_token>

export const responsePostAuthPassword_reset_token = z.any()
export type ResponsePostAuthPassword_reset_token = z.infer<typeof responsePostAuthPassword_reset_token>

interface IPostAuthPassword_reset_token extends BaseMethodType {
  tags: TagsPostAuthPassword_reset_token,
  params: ParamsPostAuthPassword_reset_token,
  body: BodyPostAuthPassword_reset_token,
  response: ResponsePostAuthPassword_reset_token
}
export const URL = '/auth/password-reset/:token'
export const validation = {
  post: {
    tags: tagsPostAuthPassword_reset_token,
    params: paramsPostAuthPassword_reset_token,
    body: bodyPostAuthPassword_reset_token,
    response: responsePostAuthPassword_reset_token
  }
}
export interface AuthPassword_reset_token extends BaseRouteType {
  post: IPostAuthPassword_reset_token
}